module.exports = __webpack_public_path__ + "static/media/landing_video.5e7a6f72.mp4";